import React, { useEffect } from 'react';
import './FloatingMessage.css'; // You'll define the styles here

const FloatingMessage = ({ message, duration = 3000, onClose, isError = false, top = '' }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!message) return null;

  const fadeOutDelay = Math.max(duration - 500, 0);

  return (
    <div className={`floating-message-card ${isError ? 'floating-error' : ''}`} style={{ top: top || undefined, animation: `fadeInSlide 0.3s ease, fadeOut 0.5s ease ${fadeOutDelay}ms forwards` }}>
      {message}
    </div>
  );
};

export default FloatingMessage;
